/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {DOMOutsideEventPlugin as ɵa} from './lib/providers/outside-event-plugin';